import React from "react";
import "./HowItWorks.scss";
import { Image } from "@sparefoot/react-commons";
import search from "assets/images/facilityPage/search.svg";
import reserve from "assets/images/facilityPage/reserve.svg";
import movein from "assets/images/facilityPage/movein.svg";
import Container from "components/core/Page/Container";

const Data = {
	title: "How to Rent a Storage Unit With Storage.com",
	subtitle:
		"There are two easy ways to secure a unit at this storage facility",
	selectUnit: "Select your storage unit",
	reserveFree: "Reserve for free",
	moveIn: "Move in"
};

export default function HowItWorks() {
	return (
		<div className="how-it-works">
			<Container>
				<div className="how-it-works-content">
					{/* Left Content */}
					<div className="how-it-works-text">
						<h2 className="how-it-works-title">{Data.title}</h2>
						<p className="how-it-works-subtitle">{Data.subtitle}</p>

						<div className="how-it-works-list">
							<div className="how-it-works-list-item">
								<span className="step-number">1</span>
								You can complete your rental process online today
								and go straight to your unit when you plan to move
								in.
							</div>
							<div className="how-it-works-list-item">
								<span className="step-number">2</span>
								You can make a reservation today with no payment
								until you sign your lease at your move-in date.
							</div>
						</div>
					</div>

					{/* Right Card */}
					<div className="info-card">
						<div className="info-card-title">How It Works</div>

						<div className="card-item">
							<Image
								src={search}
								alt="Search icon"
								className="img"
							/>
							<div>
								<span className="text">{Data.selectUnit}</span>
							</div>
						</div>

						<div className="card-item">
							<Image
								src={reserve}
								alt="Reserve icon"
								className="img"
							/>
							<div>
								<span className="text">{Data.reserveFree}</span>
								<p>
									Cancel or change your reservation at any time,
									risk-free
								</p>
							</div>
						</div>

						<div className="card-item">
							<Image
								src={movein}
								alt="Move in icon"
								className="img"
							/>
							<div>
								<span className="text">{Data.moveIn}</span>
							</div>
						</div>
					</div>
				</div>
			</Container>
		</div>
	);
}
